<template>
  <div class="rise-in max-w-2xl mx-auto">
    <div class="card card-pad">
      <div class="flex items-center gap-3 mb-2">
        <span
          class="w-11 h-11 rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center text-lg"
        >
          <font-awesome-icon icon="info-circle" />
        </span>
        <h1 class="page-title">Support</h1>
      </div>
      <p class="text-ink-soft leading-relaxed mb-6">
        Have a question, run into an issue or would you like to request an
        additional feature? Feel free to send a message and we'll get back to
        you by email as soon as possible.
      </p>

      <!-- Success state -->
      <div
        v-if="sent"
        class="flex items-start gap-3 p-4 rounded-xl bg-green-50 border border-green-100"
      >
        <font-awesome-icon
          icon="check-circle"
          class="text-green-600 mt-0.5 flex-shrink-0"
        />
        <div>
          <p class="font-semibold text-ink">Message sent — thanks!</p>
          <p class="text-sm text-ink-soft">
            We'll get back to you as soon as possible.
          </p>
          <button class="btn btn-secondary btn-sm mt-3" @click="reset">
            Send another
          </button>
        </div>
      </div>

      <!-- Contact form -->
      <template v-else>
        <p v-if="user" class="text-sm text-ink-muted mb-4">
          Sending as
          <span class="font-semibold text-ink">{{ user.email }}</span>
        </p>

        <FormulateForm class="space-y-4" @submit="onSend">
          <FormulateInput
            v-model="subject"
            type="text"
            name="subject"
            label="Subject"
            placeholder="What's this about?"
          />
          <FormulateInput
            v-model="message"
            type="textarea"
            name="message"
            label="Message"
            validation="required"
            placeholder="Describe your question or issue…"
          />
          <FormulateInput
            type="submit"
            :label="loading ? 'Sending…' : 'Send message'"
            :disabled="loading"
          />
        </FormulateForm>

        <p v-if="error" class="text-red-600 text-sm mt-3">{{ error }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from 'store/auth'
import { functions } from 'helpers/api'

export default {
  name: 'Support',
  data() {
    return {
      subject: '',
      message: '',
      loading: false,
      sent: false,
      error: null,
    }
  },
  computed: {
    ...mapGetters({ user: getterTypes.currentUser }),
  },
  methods: {
    async onSend() {
      this.error = null
      this.loading = true
      try {
        await functions.sendSupport({
          subject: this.subject,
          message: this.message,
        })
        this.sent = true
      } catch (e) {
        this.error =
          (e.response &&
            e.response.data &&
            (e.response.data.error || e.response.data.message)) ||
          e.message ||
          'Could not send your message. Please try again later.'
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.subject = ''
      this.message = ''
      this.sent = false
      this.error = null
    },
  },
}
</script>
